import type { FormBlock, FormField, ScaleRatingOptions } from 'types/forms';

import { FormFieldType } from 'types/forms';

import { omit } from './object';
import { mapFormBlocks } from './form-field-tree';
import { normalizeOptionalStrings } from './normalize-optional-strings';

// A named single row remains a matrix; only the blank marker represents a single question.
export const isSingleScaleRating = (options?: string[]): boolean =>
  options?.length === 1 && options[0]?.trim() === '';

export const normalizeScaleRatingOptions = (
  options: ScaleRatingOptions
): ScaleRatingOptions => {
  const normalized = omit(options, [
    '_rowsEnabled',
    'answerCodes',
    'answerValues',
  ]);
  const single = isSingleScaleRating(options.options);
  const answerCodes = single
    ? undefined
    : normalizeOptionalStrings(options.answerCodes, options.options.length);
  const labels = Array.isArray(options.valueLabels) ? options.valueLabels : [];
  const maxLength = options.maxValue - options.minValue + 1;
  const answerValues = normalizeOptionalStrings(
    options.answerValues,
    maxLength
  );
  return {
    ...normalized,
    ...(answerValues ? { answerValues } : {}),
    ...(answerCodes ? { answerCodes } : {}),
    options: single ? [''] : options.options,
    valueLabels:
      maxLength > 0
        ? labels
            .slice(0, maxLength)
            .map((label) => (typeof label === 'string' ? label.trim() : ''))
        : [],
  };
};

const normalizeScaleRatingField = (field: FormField): FormField => {
  if (field.type === FormFieldType.SCALE_RATING && field.options) {
    return { ...field, options: normalizeScaleRatingOptions(field.options) };
  }
  return field;
};

// Profile forms historically submitted other field definitions unchanged. Share the
// traversal, but skip the course-form rules for inputId and OUTCOMES.conditionValue.
export const normalizeScaleRatingBlocksForPayload = (blocks: FormBlock[]) =>
  mapFormBlocks(blocks, normalizeScaleRatingField);
